import React from 'react';
import { Dimensions, ScaledSize } from 'react-native';

export default function useDimensions(dim: 'screen' | 'window') {
  const [data, setData] = React.useState(Dimensions.get(dim));

  React.useEffect(() => {
    const onChange: ({ window, screen }: { window: ScaledSize; screen: ScaledSize }) => void = currentDim =>
      setData(currentDim[dim]);

    Dimensions.addEventListener('change', onChange);

    return () => {
      Dimensions.removeEventListener('change', onChange);
    };
  }, [dim]);

  return data;
}
